import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { NgForm } from '@angular/forms';
import { Productcategory } from 'src/app/model/productcategory.model';
import { Route } from '@angular/compiler/src/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-editproduct',
  templateUrl: './editproduct.component.html',
  styleUrls: ['./editproduct.component.css']
})
export class EditproductComponent implements OnInit {

  product : Products;
  category : Productcategory;
  productid: string;
  readonly rootUrl = environment.baseUrl;
  

  constructor(private productServices: ProductService, private router: Router, private route: ActivatedRoute) {
    this.product = new Products();
    this.productid = this.route.snapshot.params.productid;
   }

  ngOnInit() {
    this.getProductCategory();
    this.getProductById();
  }

  getProductCategory()
  {
    this.productServices.getProductCategory().subscribe(
      (data : any) => {
        this.category = data;
        console.log(this.category);
      }
    )
  }

  getProductById()
  {
    this.productServices.getProductById(this.productid).subscribe(
      (data : any) => {
        this.product = data;
        console.log(this.product);
      }
    )
  }

  editProduct(form: NgForm) {
    console.log(form.value);
    //alert(form.value.price);
    var validPrice = new RegExp(/^\d*\.?\d*$/);
    if (validPrice.test(form.value.price)) {
      
    } else {
      alert("Please input valid price");
      return false;
    }
    
    if(form.value.outOfStock == "true")
    {
      form.value.outOfStock = true;
    }
    else{
      form.value.outOfStock = false;
    }
    form.value.unitsPerCase = parseInt(form.value.unitsPerCase);
    if(isNullOrUndefined(form.value.quantity))
    {
      form.value.quantity = 0;
    }
    form.value.quantity = parseInt(form.value.quantity);
    form.value.id = this.productid;
    form.value.productCode = this.product.productCode;

    if(!form.value.productImage || form.value.productImage == null || form.value.productImage == "" )
    {
      form.value.productImage = this.rootUrl + "/images/noimage.png";
    }

    this.productServices.UpdateProduct(form.value)
      .subscribe((data: any) => {
        if (data == true) {
          alert("Product updated successfully");
          this.router.navigate(['/productlist']);
        }
        else {
          alert("An Error Occured");
        }
      });
  }

}
